import cn from 'classnames';
import React from 'react';
import { H3 } from 'components/Heading';

import { useToggleCard } from './ToggleCardContext';
import { ToggleCardSize } from './types';
import { block } from './utils';

export interface ToggleCardInfoProps {
  children?: React.ReactNode;
  hidden?: boolean;
  icon?: React.ReactNode;
  size: ToggleCardSize;
}

const ToggleCardInfo: React.FC<ToggleCardInfoProps> = ({
  children,
  hidden,
  icon,
  size,
}) => {
  const { theme } = useToggleCard();

  return (
    <div className={block('info', { hidden, [size]: true })}>
      {React.isValidElement(icon) &&
        React.cloneElement(icon, {
          className: cn(
            icon.props.className,
            block('info-icon', { [theme]: !!theme, [size]: true }),
          ),
        })}
      <H3 className={block('text', { [size]: true })}>{children}</H3>
    </div>
  );
};

export default ToggleCardInfo;
